import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/tutorial-en.json';
import koTranslation from './locales/tutorial-kr.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ko: { translation: koTranslation },
    },
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
